import Swiper from 'swiper';
const lazy = new LazyLoad();

export function productSlider() {

    const body = $("body");
    const gallery = $(".woo-product-gallery");
    const gallery_window = $(".woo-product-gallery-window");

    let main_options = {
        slidesPerView: 1,
        loopedSlides: 0,
        loopAdditionalSlides: 0,
        simulateTouch: true,
        speed: 600,
        loop: true,
        autoHeight: false,
        on: {
            init: function () {
                lazy.update()
                gallery.find('.thumbs .swiper-slide[data-ind="1"]').addClass("selected").siblings().removeClass("selected");
            },
            realIndexChange: function (e) {
                thumbs.slideTo(e.activeIndex - 2);
                gallery.find('.thumbs .swiper-slide[data-ind="'+e.activeIndex+'"]').addClass("selected").siblings().removeClass("selected");
            },
            slideChange: function (e) {
                lazy.update()

                gallery.find(".video-file").each(function () {
                    let vid = $(this).find("video");
                    vid.trigger('pause');
                    // console.log(vid);
                })

                gallery.find(".youtube-vid").each(function () {
                    this.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*')
                })

            },
            transitionStart: function (e) {
            },
            transitionEnd: function (e) {
                //dublicate fix
                gallery.find(".main .swiper-slide.swiper-slide-duplicate").each(function () {
                    let me = $(this);
                    let klas = me.attr("class");

                    if(klas == "swiper-slide swiper-slide-duplicate swiper-slide-prev swiper-slide-duplicate-next") {
                        let newInd = e.realIndex + 1;
                        // console.log(newInd);
                        if(thumbs) thumbs.slideTo(newInd)
                        gallery.find('.thumbs .swiper-slide[data-ind="'+newInd+'"]').addClass("selected").siblings().removeClass("selected");
                    }

                    if(klas == "swiper-slide swiper-slide-duplicate swiper-slide-next swiper-slide-duplicate-prev") {
                        let newInd = e.realIndex + 1;
                        thumbs.slideTo(newInd)
                        gallery.find('.thumbs .swiper-slide[data-ind="'+newInd+'"]').addClass("selected").siblings().removeClass("selected");
                        gallery.find('.thumbs .swiper-slide[data-ind="'+newInd+'"]').trigger("click")
                    }

                });

            },
        },
        navigation: {
            nextEl: '.woo-product-gallery .main .js-slider-next',
            prevEl: '.woo-product-gallery .main .js-slider-prev'
        },
    };

    let thumb_options = {
        slidesPerView: 'auto',
        slidesPerGroupAuto: true,
        simulateTouch: false,
        spaceBetween: 10,
        speed: 600,
        loop: false,
        autoHeight: true,
        on: {
            init: function () {
                lazy.update()
            },
            realIndexChange: function (e) {
                // console.log(e.activeIndex);
            },
            slideChange: function () {
                lazy.update()
            },
        }
    };

    let window_main_options = {
        slidesPerView: 1,
        loopedSlides: 0,
        loopAdditionalSlides: 0,
        simulateTouch: true,
        speed: 600,
        loop: true,
        autoHeight: false,
        on: {
            init: function () {
                lazy.update()
                gallery_window.find('.thumbs .swiper-slide[data-ind="1"]').addClass("selected").siblings().removeClass("selected");
            },
            slideChange: function (e) {
                lazy.update()

                gallery_window.find('.thumbs .swiper-slide[data-ind="'+e.activeIndex+'"]').addClass("selected").siblings().removeClass("selected");
                main.slideTo(e.activeIndex);

                gallery_window.find(".video-file").each(function () {
                    let vid = $(this).find("video");
                    vid.trigger('pause');
                    // console.log(vid);
                })

                gallery_window.find(".youtube-vid").each(function () {
                    this.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*')
                })

            },
            transitionEnd: function (e) {
                //dublicate fix

                gallery_window.find(".main .swiper-slide.swiper-slide-duplicate").each(function () {
                    let me = $(this);
                    let klas = me.attr("class");

                    if(klas == "swiper-slide swiper-slide-duplicate swiper-slide-prev swiper-slide-duplicate-next") {
                        let newInd = e.realIndex + 1;
                        gallery_window.find('.thumbs .swiper-slide[data-ind="'+newInd+'"]').addClass("selected").siblings().removeClass("selected");
                    }

                    if(klas == "swiper-slide swiper-slide-duplicate swiper-slide-next swiper-slide-duplicate-prev") {
                        let newInd = e.realIndex + 1;
                        gallery_window.find('.thumbs .swiper-slide[data-ind="'+newInd+'"]').addClass("selected").siblings().removeClass("selected");
                    }

                });

            },
        },
        navigation: {
            nextEl: '.woo-product-gallery-window .main .js-slider-next',
            prevEl: '.woo-product-gallery-window .main .js-slider-prev'
        },
    };

    let window_thumb_options = {
        slidesPerView: 'auto',
        slidesPerGroupAuto: true,
        simulateTouch: false,
        centeredSlides: true,
        centerInsufficientSlides: true,
        centeredSlidesBounds: true,
        spaceBetween: 10,
        speed: 600,
        loop: false,
        autoHeight: false,
        on: {
            init: function () {
                lazy.update()
            },
            realIndexChange: function (e) {
                // console.log(e.activeIndex);
            },
            slideChange: function () {
                lazy.update()
            },
        }
    };

    let main = new Swiper(".woo-product-gallery .main-slider", main_options);
    let thumbs = new Swiper(".woo-product-gallery .thumbs-slider", thumb_options);

    let window_main = new Swiper(".woo-product-gallery-window .main .swiper-container", window_main_options);
    let window_thumbs = new Swiper(".woo-product-gallery-window .thumbs .swiper-container", window_thumb_options);

    gallery.find(".main img").on("click tap", function () {

        let ind = $(this).closest('.swiper-slide').data('ind');

        window_main.slideTo(ind,0);

        setTimeout(function () {
            gallery_window.removeClass("hidden");
        }, 0);

        setTimeout(function () {
            body.addClass("show-gallery-window");
            fixSlideImgHeight();
        }, 100);

    });

    $(".thumbs .swiper-slide").on("click tap", function () {
        let me = $(this);
        let ind = me.data("ind");
        me.addClass("selected").siblings().removeClass("selected");

        // console.log(ind);
        main.slideTo(ind,0);
        window_main.slideTo(ind,0);
        if(thumbs)  thumbs.slideTo(ind -2);

        $('.main .swiper-slide[data-ind="'+ind+'"]').stop().hide().fadeIn("fast");

    });

    $(".close-gallery-window").on("click tap", function () {
        body.removeClass("show-gallery-window");

        setTimeout(function() {
            gallery_window.addClass("hidden");
        }, 300);

    });

    function getInnerHeight( elm ) {
        var computed = getComputedStyle(elm),
            padding = parseInt(computed.paddingTop) + parseInt(computed.paddingBottom);

        return elm.clientHeight - padding
    }

    function fixSlideImgHeight() {
        let selector = document.querySelector(".woo-product-gallery-window .main .swiper-slide");
        let swiper_content_h = getInnerHeight(selector);
        gallery_window.find(".main img").css("max-height", swiper_content_h);
        // console.log(swiper_content_h)
    }

    $(window).on("resize", fixSlideImgHeight);

}

